const header = {
    about_rebless_clinic: "리블레스 클리닉",
    rebless_app: "리블레스 앱",
    faq: "자주 묻는 질문",
    go_to_rebless_clinic: "리블레스 클리닉 바로가기"
}

export default header;